import React, { createContext, ReactNode, useContext, useState } from 'react';

export interface MobileRotationContextType {
  isRotationModalOpen: boolean;
  showRotationModal: () => void;
  hideRotationModal: () => void;
  isDismissed: boolean;
  setIsDismissed: (isDismissed: boolean) => void;
  dismissPermanently: () => void;
}

const MobileRotationContext = createContext<MobileRotationContextType | null>(null);

export const useMobileRotation = (): MobileRotationContextType => {
  const context = useContext(MobileRotationContext);
  if (!context) {
    throw new Error('useMobileRotation must be used within MobileRotationProvider');
  }
  return context;
};

export const MobileRotationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isRotationModalOpen, setIsRotationModalOpen] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  const showRotationModal = () => {
    if (!isDismissed) {
      setIsRotationModalOpen(true);
    }
  };

  const hideRotationModal = () => {
    setIsRotationModalOpen(false);
  };

  const dismissPermanently = () => {
    setIsDismissed(true);
    setIsRotationModalOpen(false);
  };

  return (
    <MobileRotationContext.Provider
      value={{
        isRotationModalOpen,
        showRotationModal,
        hideRotationModal,
        isDismissed,
        setIsDismissed,
        dismissPermanently,
      }}
    >
      {children}
    </MobileRotationContext.Provider>
  );
};
